import { render, staticRenderFns } from "./AppointmentsHistory.vue?vue&type=template&id=6bed0694&"
import script from "./AppointmentsHistory.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports